// -- Packages
// -- Prime React
// -- Local
import { Service } from "../models/Service";
import { ServiceSearch } from "../models/ServiceSearch";
import Http, { HttpOptions } from "./Https";

class PortalServices {
   async SearchServicesAsync(
      searchCriteria: ServiceSearch
   ): Promise<Service[]> {
      const options: HttpOptions = {
         url: "ServicesPortal/Search",
         waitMessage: "Searching Services",
         data: searchCriteria,
      };

      const response = await Http.post<Service[]>(options);
      return response;
   }

   async GetServiceByIdAsync(serviceId: number): Promise<Service> {
      const options: HttpOptions = {
         url: "ServicesPortal/Detail/" + serviceId,
         waitMessage: "Getting Service",
      };

      const response = await Http.get<Service>(options);
      return response;
   }
}

export default new PortalServices();
